import { Platform } from "@-/com.npmjs.react-native";

/** Expo Router listens to browser traversal; native stacks re-push their retained redo frame. */
export function learnDeckBrowserForward(): boolean {
  if (Platform.OS === "web") {
    globalThis.history.forward();
    return true;
  }
  return false;
}

/** Explicit browser traversal can overtake React's acknowledgment of a programmatic push. */
export function subscribeLearnDeckBrowserTraversal(onTraverse: () => void): () => void {
  if (Platform.OS !== "web") {
    return () => {};
  }
  globalThis.addEventListener("popstate", onTraverse);
  return () => globalThis.removeEventListener("popstate", onTraverse);
}
